import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocatieServiciiActive, LocatieServiciiActiveUpdate } from './locatii-servicii.interface';

@Injectable({
    providedIn: 'root'
})
export class LocatiiServiciiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getLocatiiServiciiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatiiServiciiActive.getLocatiiServicii;
    private storeLocatieServiciiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatiiServiciiActive.storeLocatieServicii;
    private updateLocatieServiciiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatiiServiciiActive.updateLocatieServicii;
    private deleteLocatieServiciiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatiiServiciiActive.deleteLocatieServicii;
    private moveUpUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatiiServiciiActive.moveUp;
    private moveDownUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatiiServiciiActive.moveDown;

    constructor(private http: HttpClient) { }

    addLocatieServicii(locatieServicii: LocatieServiciiActive) {
        return this.http.post(this.storeLocatieServiciiUrl, locatieServicii, this.httpOptions);
    }

    updateLocatieServicii(locatieServicii: LocatieServiciiActiveUpdate) {
        return this.http.put(this.updateLocatieServiciiUrl, locatieServicii, this.httpOptions);
    }

    deleteLocatieServicii(id: number) {
        return this.http.delete(this.deleteLocatieServiciiUrl + id);
    }

    getLocatiiServicii() {
        return this.http.get(this.getLocatiiServiciiUrl, this.httpOptions);
    }

    moveUp(id: number) {
        return this.http.put(this.moveUpUrl + id, this.httpOptions);
    }

    moveDown(id: number) {
        return this.http.put(this.moveDownUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
